<template>
  <div class="corporation-page">
    <layout>
      <template v-slot:search>
        <div class="search-wrapper">
          <div class="title"><a-icon type="search" /> 数据筛选</div>
          <a-divider></a-divider>
          <a-space>
            <a-input allow-clear placeholder="名称" v-model="queryParam.name" />
            <a-button type="primary" @click="search">查询</a-button>
            <a-button @click="resetSearch">重置</a-button>
          </a-space>
        </div>
      </template>

      <template v-slot:content>
        <a-space class="table-operator">
          <a-button type="primary" icon="plus" @click="create" v-if="accessTo('store')">添加</a-button>
          <a-dropdown :disabled="selectedRowKeys.length === 0" v-if="accessTo('destroy')">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="destroy()"><a-icon type="delete" />删除</a-menu-item>
            </a-menu>
            <a-button> 批量操作 <a-icon type="down" /></a-button>
          </a-dropdown>
        </a-space>

        <a-table
          :columns="columns"
          :row-key="record => record.id"
          :data-source="data"
          :row-selection="{ onChange: onSelectChange }"
          :pagination="pagination"
          :loading="loading"
          :transform-cell-text="$helper.emptyFormat"
          @change="handleTableChange"
        >
          <div slot="action" slot-scope="record" class="actions">
            <template v-if="accessTo([
              'update',
              'destroy'
            ])">
              <a href="javascript:;" @click="create(record)" v-if="accessTo('update')">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认要删除吗?" @confirm="destroy(record)" v-if="accessTo('destroy')">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template v-else>-</template>
          </div>
        </a-table>
      </template>
    </layout>
    <create-form
      v-if="showForm"
      :showForm.sync="showForm"
      :model="model"
      @success="refresh"
    />
  </div>
</template>

<style lang="less" scoped>
@import 'Corporation';
</style>

<script>
import Corporation from './Corporation'
export default Corporation
</script>
